$('.js-map-button').click(function () {
    $('#search_form').attr('action','/find/map/').find('button').click();
})